import React from 'react';
import { Job, ComeetEmbedConfig } from '../../../lib/comeet';
import { JobPage } from '../../components/JobPage';
import { DEFAULT_JOB_HERO_IMAGE } from '../../../consts/jobHeroImages';
import { BIProvider, PAGE_NAMES } from '../../bi';

interface JobsProps {
    job?: Job;
    heroImage?: string;
    isBlockedCountry?: boolean;
    comeetEmbedConfig?: ComeetEmbedConfig;
}

const Jobs = ({ job, heroImage, isBlockedCountry, comeetEmbedConfig }: JobsProps) => {
    if (!job) {
        return null;
    }
    return (
        <BIProvider pageName={PAGE_NAMES.jobs}>
            <JobPage
                job={job}
                heroImage={heroImage ?? DEFAULT_JOB_HERO_IMAGE}
                isBlockedCountry={isBlockedCountry}
                comeetEmbedConfig={comeetEmbedConfig}
            />
        </BIProvider>
    );
};

export default Jobs;
